<div class="input-group">
  <input
    data-1p-ignore
    data-bwignore
    data-lpignore="true"
    data-form-type="other"
    autocomplete="off"
    class="form-control"
    [placeholder]="placeholder()"
    [value]="formattedDate()"
    [(ngModel)]="date"
    (blur)="onBlur()"
    ngbDatepicker
    #d="ngbDatepicker"
    aria-describedby="toggle-button"
    [required]="required()"
    [minDate]="minDate()"
    [maxDate]="maxDate()"
  />

  <button class="input-group-text" id="toggle-button" (click)="d.toggle()" type="button">
    <span class="visually-hidden">{{ 'component.datepicker.toggle-datepicker' | translate }}</span>
    <fa-icon [icon]="['fas', 'calendar-alt']"></fa-icon>
  </button>
</div>
